import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";

import {
  createSellRow,
  customDate,
  getBrandAndModel,
  getProductPrice,
  getProductDiscount,
  getProductInfoSells,
} from "../../../_utils/utils";
import { selectHeaders } from "./header";
import {
  formatter,
  getProductTypeCounterAccesory,
  nameSeller,
  siteName,
  totalPriceSells,
} from "./utilsReports";

export const createTicketReport = (
  totalSellsArray,
  startDate,
  endDate,
  typeOfReport
) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [197, 80],
  });
  doc.setFontSize(6);

  /** ==== HEADER ===== */
  const initDate = startDate.split("T")[0];
  const parsedInitDate = moment(initDate, "YYYY-MM-DD").format("DD-MM-YYYY");
  const finishDate = endDate.split("T")[0];
  const parsedFinishDate = moment(finishDate, "YYYY-MM-DD").format(
    "DD-MM-YYYY"
  );
  doc.text("Reporte de ventas -  Telcel Sierra Movil", 4, 6);
  doc.text(
    `${siteName(typeOfReport, totalSellsArray)} ${nameSeller(
      typeOfReport,
      totalSellsArray
    )}`,
    4,
    9
  );
  doc.text(
    `Fechas de consulta:  ${parsedInitDate} al ${parsedFinishDate} `,
    4,
    12
  );
  doc.text(
    `Total de ventas ${formatter.format(totalPriceSells(totalSellsArray))}`,
    4,
    18
  );

  doc.setFontSize(6);

  autoTable(doc, {
    head: [selectHeaders(typeOfReport)],
    headStyles: {
      cellWidth:
        typeOfReport === "sellsByUser"
          ? 10
          : typeOfReport === "sellsBySite"
          ? 9
          : 8,
      cellPadding: 1,
    },
    margin: { top: 25, left: 1 },
    theme: "plain",
    styles: {
      fontSize: 6,
      cellWidth: "auto",

      font: "times",
    },
    body: generateRows(totalSellsArray, typeOfReport),
  });
  doc.save(`reporte-ventas-${initDate}_${finishDate}.pdf`);
};

const generateRows = (totalSellsArray, typeOfReport) => {
  const buildRow = [];

  /** row builder for ticket report */
  totalSellsArray.forEach((item) => {
    buildRow.push(
      createSellRow(
        typeOfReport,
        item.site.name,
        getProductTypeCounterAccesory(item),
        getBrandAndModel(item, false),
        getProductInfoSells(item),
        item.product.movile?.barCode ||
          item.product.accesory?.barCode ||
          item.product.chip?.chip_catalogue?.barCode ||
          item.product.cash_card?.card_catalogue?.barCode ||
          "N/A",
        getProductPrice(item),
        getProductDiscount(item),
        item.user?.name,
        customDate(item.createdAt),
        item.product?.movile?.lote || item.product?.chip?.lote || ""
      )
    );
  });
  return buildRow;
};
